import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export default function DocumentMeta() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const title = t('meta.title');
    const description = t('meta.description');
    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    document.documentElement.setAttribute('lang', i18n.language?.startsWith('ru') ? 'ru' : 'en');
  }, [t, i18n.language]);
  return null;
}
